<template>
  <section>
    <div class="rounded-lg bg-white shadow">

      <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6"> <!-- -->

        <div class="mb-8">
          <h3 class="text-2xl leading-6 font-medium text-gray-900">{{ name }} #{{ id }} </h3>
          <p class="mt-1 text-sm text-gray-500">
            Заполните общую информацию о мероприятии, затем установите сумму оплаты и скидки, далее внесите информацию
            для координатора, добавьте вопросы и задания, распределите места, подгрузите шаблоны. После того,как вы
            внесете всю информацию - необходимо активировать мероприятие, тогда оно появиться на сайте.
          </p>
        </div>

        <div class="lg:grid lg:grid-cols-12 lg:gap-x-5">
          <aside class="py-6 pr-2 sm:px-6 lg:py-0 lg:px-0 lg:col-span-3">
            <nav class="space-y-1">

              <router-link :to="{name: 'EventEditAbout'}" class="menu-item " role="link">
                <ui-icon-template/>
                <span class="truncate">Общая информация</span>
              </router-link>
              <router-link :to="{name: 'EventEditPay'}" class="menu-item " role="link">
                <ui-icon-cash/>
                <span class="truncate">Купоны на скидку</span>
              </router-link>
              <router-link :to="{name: 'EventEditMentor'}" class="menu-item " role="link">
                <ui-icon-document-download/>
                <span class="truncate">Для координатора</span>
              </router-link>
              <router-link to="questions" class="menu-item " role="link">
                <ui-icon-question-mark-circle/>
                <span class="truncate">Задания/вопросы</span>
              </router-link>
              <router-link :to="{name: 'EventEditResult'}" class="menu-item " role="link">
                <ui-icon-printer/>
                <span class="truncate">Итоги/шаблоны</span>
              </router-link>

            </nav>
          </aside>

          <div class="space-y-6   lg:col-span-9">
            <router-view/>
          </div>
        </div>

      </div>


    </div>
  </section>
</template>

<script>

import UiIconCash from "@/components/ui/icons/UiIconCash";
import UiIconTemplate from "@/components/ui/icons/UiIconTemplate";
import UiIconDocumentDownload from "@/components/ui/icons/UiIconDocumentDownload";
import UiIconQuestionMarkCircle from "@/components/ui/icons/UiIconQuestionMarkCircle";
import UiIconPrinter from "@/components/ui/icons/UiIconPrinter";
import {mapGetters} from "vuex";

export default {
  name: "EventEdit",
  components: {UiIconPrinter, UiIconQuestionMarkCircle, UiIconDocumentDownload, UiIconTemplate, UiIconCash},
  props: ['id'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters('event', ['name']),

  },
  methods: {
    eventLoad(id) {
      this.$store.dispatch('event/load', id);
    },
  },
  watch: {
    id(val) {
      this.eventLoad(val);
    }
  },
  mounted() {
    this.eventLoad(this.id);

  }
}
</script>

<style scoped lang="scss">
.menu-item {
  @apply text-gray-800   rounded-md px-3 py-2 flex items-center text-sm font-medium;
  // group

  &:hover {
    @apply text-gray-900 bg-gray-50;
    svg {
      @apply text-gray-500;
    }
  }

  &.router-link-active {
    @apply bg-gray-100 text-orange-700;
    svg {
      @apply text-orange-700;
    }

    //hover:text-indigo-700 hover:bg-white
  }

  svg {
    @apply text-gray-400  flex-shrink-0 -ml-1 mr-3 h-6 w-6;
  }
}

</style>